import { Column } from 'primereact/column';
import { DataTable, DataTableRowClickEvent } from 'primereact/datatable';
import React, { useState } from 'react';
import ResponsiveTopRequestorListAccordion from '../ResponsiveTopRequestorListAccordion';
import { ProgressSpinner } from 'primereact/progressspinner';

const ResponsiveRequestorAccordion = ({ openAcoordionResponsive, setOpenAcoordionResponsive, isLoading, requestorListData }: any) => {
    const [jobListData, setJobListData] = useState<any>([]);

    const GetName = (row: any) => (
        <div className="text-gray100 text-xs font-medium flex">
            <p className="mr-6 max-md:mr-3">{row.requestorName}</p>
        </div>
    );

    const GetJobs = (row: any) => (
        <div className="text-gray100 text-xs font-medium flex">
            <p className="mr-6 max-md:mr-3">{row.totalJobsAssigned} job</p>
        </div>
    );

    const GetHours = (row: any) => (
        <div className="text-gray100 text-xs font-medium flex">
            <p className="mr-6 max-md:mr-3">{row.totalWorkingHours} hrs.</p>
        </div>
    );

    const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});

    const onRowClick = (e: DataTableRowClickEvent) => {
        const selectedId = e.data.requestorID.toString();
        const isAlreadyExpanded = expandedRows[selectedId];

        if (isAlreadyExpanded) {
            setExpandedRows({});
            setJobListData([]);
        } else {
            const filteredJobs = requestorListData.jobList.filter((job: any) => Number(job.requestorId) === Number(selectedId));
            const processedJobs = filteredJobs.map((element: any) => {
                const parsedEmployees = typeof element.employeeList === 'string' ? JSON.parse(element.employeeList) : element.employeeList;
                return { ...element, employeeList: parsedEmployees };
            });
            setJobListData(processedJobs);
            setExpandedRows({ [selectedId]: true });
        }
    };

    const rowExpansionTemplate = (data: any) => (
        <div className=" px-4 max-h-[400px] overflow-y-auto">
            <ResponsiveTopRequestorListAccordion
                jobListData={jobListData}
                modalOpenTopResponsive={''}
                openAcoordionResponsive={openAcoordionResponsive}
                setOpenAcoordionResponsive={setOpenAcoordionResponsive}
            />
        </div>
    );

    return (
        <div className="w-full">
            {isLoading ? (
                <div className="card w-full h-full flex justify-content-center items-center ">
                    <ProgressSpinner />
                </div>
            ) : (
                <DataTable
                    value={requestorListData.requestorList}
                    dataKey="requestorID"
                    expandedRows={expandedRows}
                    rowExpansionTemplate={rowExpansionTemplate}
                    onRowClick={onRowClick}
                    emptyMessage="No Record Found"
                    rowClassName={(data: any) =>
                        expandedRows && expandedRows[data.requestorID] ? '!bg-[#f2f4f7]' : 'hover:cursor-pointer hover:!bg-[#f2f4f7] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]'
                    }
                >
                    <Column field="requestorName" header="Name" body={GetName} />
                    <Column field="totalJobsAssigned" header="Total Jobs" body={GetJobs} />
                    <Column field="totalWorkingHours" header="Total Hours" body={GetHours} />
                </DataTable>
            )}
        </div>
    );
};

export default ResponsiveRequestorAccordion;
